import { render } from "./AccordionFormHeading.vue?vue&type=template&id=34a70688&scoped=true"
import script from "./AccordionFormHeading.vue?vue&type=script&lang=js"
export * from "./AccordionFormHeading.vue?vue&type=script&lang=js"

import "./AccordionFormHeading.vue?vue&type=style&index=0&id=34a70688&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a70688"]])

export default __exports__